import React, { useEffect, useRef, useState } from "react";
import { ImageCropper, SelectPicker, UploadDocument } from "../../components/componentIndex";
import { Button, CheckedImage, DatePicker, Input, Select } from "../../common/commonIndex";
import { useNavigate } from "react-router-dom";
import defaultIcon from '../../assets/images/profile-user.svg';
import cameraIcon from '../../assets/images/photo-camera.svg';
import addStoryIcon from '../../assets/images/circle-camera.svg';
import PersonalInformationService from '../../services/API/personalInformationService';
import { useAuthenticationContext } from "services/slices/AuthenticationSlicer";
import DocumentService from '../../services/API/documentService';
import CommonService from '../../services/API/commonService';
import { DocumentType } from "helper/enum";
import imageCompression from "browser-image-compression";

const MAX_FILE_SIZE = 384495; // 375 KB

const Profile = () => {
    const navigate = useNavigate();
    const [patientDocument, setPatientDocument] = useState({});
    const [cities, setCities] = useState({});
    const [zipCodeList, setZipCodeList] = useState({});
    const [states, setStates] = useState([]);
    const [isFetching, setIsFetching] = useState(false);
    const [isDatePicker, setIsDatePicker] = useState(false);
    const [isSave, setIsSave] = useState(false);
    const [formData, setFormData] = useState('');
    const [identityImg, setIdentityImg] = useState(null);
    const [insuranceFront, setInsuranceFront] = useState(null);
    const [insuranceBack, setInsuranceBack] = useState(null);
    const [isDocument, setIsDocument] = useState(false);
    const [isCropTool, setIsCropTool] = useState(false);
    const [countrtCode, setCountrtCode] = useState('1');
    const [stateId, setStateId] = useState(1);
    const [isSubmit, setIsSubmit] = useState(false); // To track validation errors
    const [errors, setErrors] = useState({}); // To track validation errors
    const { state: data, dispatch } = useAuthenticationContext();
    const popupRef = useRef(null);
    const [patientInfo, setPatientInfo] = useState({
        profile: null,
        firstName: '',
        lastName: '',
        gender: '',
        pronoun: '',
        dateOfBirth: '',
        mobileNumber: '',
        email: '',
        streetAddress: '',
        aptSuite: '',
        city: '',
        state: '',
        zipCode: '',
    });

    let uploadDocuments = [
        { question: 'Add Photo ID', title: 'Identification' },
        { question: 'FRONT of Insurance Card', title: 'Insurance cards' },
        { question: 'BACK of Insurance Card', title: null },
    ];
    let genders = [
        { name: 'Other', value: 1 },
        { name: 'Male', value: 2 },
        { name: 'Female', value: 3 },
        { name: 'Select', value: 4 },
    ];
    let pronouns = [
        { name: 'He/Him', value: 1 },
        { name: 'She/Her', value: 2 },
        { name: 'They/Them', value: 3 },
        { name: 'Optional', value: 4 },
    ];


    useEffect(() => {
        getDemographicsState();
        getPersonalInformation(false);
        getIdentity();
        // getInsurance();
    }, [setIsSave, isSave]);

    const getDemographicsState = async () => {
        try {
            const accessToken = data?.userData?.result?.token;
            setIsFetching(true);
            const response = await CommonService.getDemographicsState(accessToken);
            if (response?.statusCode === 200) {
                setStates(response?.result);
            }
        } catch (error) {
            console.error('Error fetching top doctors:', error);
        } finally {
            setIsFetching(false);
        }
    }
    const getCities = async (stateId) => {
        try {
            const accessToken = data?.userData?.result?.token;
            setIsFetching(true);
            const response = await CommonService.getCities(stateId, accessToken);
            if (response?.statusCode === 200) {
                setCities(response?.result);
            }
        } catch (error) {
            console.error('Error fetching top doctors:', error);
        } finally {
            setIsFetching(false);
        }
    }
    const getStateZipCodes = async (cityId) => {
        try {
            const accessToken = data?.userData?.result?.token;
            setIsFetching(true);
            const response = await CommonService.getStateZipCodes(cityId, accessToken);
            if (response?.statusCode === 200) {
                setZipCodeList(response?.result);
            }
        } catch (error) {
            console.error('Error fetching top doctors:', error);
        } finally {
            setIsFetching(false);
        }
    }

    const getIdentity = async () => {
        try {
            const accessToken = data?.userData?.result?.token;
            const response = await DocumentService.getIdentity(accessToken);
            if (response?.statusCode === 200) {
                setIdentityImg(response?.result?.documentSignedUrl);
                getInsurance();
            }
        } catch (error) {
            console.error('Error fetching top doctors:', error);
        }
    }
    const getInsurance = async () => {
        try {
            const accessToken = data?.userData?.result?.token;
            const response = await DocumentService.getInsurance(accessToken);
            if (response?.statusCode === 200) {
                setInsuranceFront(response?.result?.insuranceFront);
                setInsuranceBack(response?.result?.insuranceBack);
                setTimeout(() => {
                    setIsDocument(true);
                }, 50);
            }
        } catch (error) {
            console.error('Error fetching top doctors:', error);
        }
    }

    useEffect(() => {
        if (identityImg) {
            setPatientDocument((prev) => ({
                ...prev,
                [0]: { answer: identityImg },
            }));
        }

        if (insuranceFront) {
            setPatientDocument((prev) => ({
                ...prev,
                [1]: { answer: insuranceFront },
            }));
        }
        if (insuranceBack) {
            setPatientDocument((prev) => ({
                ...prev,
                [2]: { answer: insuranceBack },
            }));
        }


    }, [identityImg, insuranceFront, insuranceBack])
    setTimeout(() => {
        console.log('setPatientDocument', patientDocument);
    }, 300);
   
    const getPersonalInformation = async (isPersonalInfo) => {
        try {
            const accessToken = data?.userData?.result?.token;
            setIsFetching(true);
            const response = await PersonalInformationService.getPersonalInformation(accessToken);
            if (response?.statusCode === 200) {
                if (response?.result?.listOfCities?.length > 0) {
                    const obj = {
                        id: 0,
                        name: 'Select city'
                    }
                    response?.result?.listOfCities.push(obj);
                }
                if (response?.result?.listOfZipCode?.length > 0) {
                    const obj = {
                        id: 0,
                        zip: 'Select zipCode'
                    }
                    response?.result?.listOfZipCode.push(obj);
                }


                // Extract 10 digits before the last 10 digits
                const last20Digits = response?.result?.phoneNumber.replace(/\D/g, '').slice(-20, -10);
                setCountrtCode(last20Digits && last20Digits !== '' ? last20Digits : '1');
                setCities(response?.result?.listOfCities);
                setZipCodeList(response?.result?.listOfZipCode);
                
                setPatientInfo({
                    profile: response?.result?.profileSignedUrl || null,
                    firstName: response?.result?.firstName || '',
                    lastName: response?.result?.lastName || '',
                    gender: response?.result?.fkGenderId || 4,
                    pronoun: response?.result?.fkPronounId || '',
                    dateOfBirth: response?.result.dateOfBirth || '',
                    mobileNumber: response?.result?.phoneNumber && response?.result?.phoneNumber !== '' ? response?.result?.phoneNumber?.slice(-10) : '' || '',
                    email: response?.result?.emailAddress || '',
                    streetAddress: response?.result?.address || '',
                    aptSuite: response?.result?.address || '',
                    city: response?.result.fkCityId || '',
                    state: response?.result.stateName || '',
                    zipCode: response?.result.fkZipCodeId || '',
                });
                setFormData(new Date(response?.result.dateOfBirth));
                if (isPersonalInfo) {
                    setLocalStorage(response?.result);
                }
            }
        } catch (error) {
            console.error('Error fetching top doctors:', error);
        } finally {
            setIsFetching(false);
        }
    }

    const setLocalStorage = (responseData) => {
        let localData;
        localData = JSON.parse(localStorage.getItem('userData'));
        localData.result.email = responseData.emailAddress;
        localData.result.first_name = responseData.firstName;
        localData.result.last_name = responseData.lastName;
        localData.result.phone_number = responseData.phoneNumber;
        localData.result.dob = responseData.dateOfBirth;
        localData.result.fkGenderId = responseData.fkGenderId;
        localData.result.profileSignedUrl = responseData.profileSignedUrl;

        dispatch({
            type: "LoginUserSuccess",
            payload: localData,
        });
        localStorage.setItem('userData', JSON.stringify(localData))
    }
    // Validation function for individual fields
    const validateField = (name, value) => {
        let error = '';
        switch (name) {
            case 'firstName':
                if (!value) error = 'First name is required';
                break;
            case 'lastName':
                if (!value) error = 'Last name is required';
                break;
            case 'email':
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!value) error = 'Email is required';
                else if (!emailPattern.test(value)) error = 'Invalid email format';
                break;
            
            case 'zipCode':
                const zipPattern = /^\d{5}$/;
                if (!value) error = 'Zip code is required';
                else if (!zipPattern.test(value)) error = 'Invalid zip code';
                break;
            default:
                break;
        }
        return error;
    };

    const handleChange = (fieldName) => (event) => {
        if (fieldName === 'dateOfBirth') {
            setIsDatePicker(true);
        }
        setPatientInfo({ ...patientInfo, [fieldName]: event });
        const error = validateField(fieldName, event);
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: error }));
    };

    const handleSubmit = async (event) => {
        setIsSubmit(true)
        event.preventDefault();
        try {
            const dateObj = new Date(patientInfo?.dateOfBirth);
            // Format the date into yyyy/mm/dd
            const formattedDate = `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`;
            let obj = {
                "firstName": patientInfo.firstName,
                "lastName": patientInfo.lastName,
                "fkGenderId": parseInt(patientInfo?.gender), ///genders?.find(x => x?.name?.toLowerCase() === patientInfo?.gender?.toLowerCase())?.value,
                "fkPronounId": parseInt(patientInfo.pronoun),
                "address": patientInfo.streetAddress,
                "fkCityId": parseInt(patientInfo.city),
                "fkStateId": parseInt(stateId),
                "fkZipCodeId": parseInt(patientInfo.zipCode),
                "phoneNumber": patientInfo?.mobileNumber?.length > 9 ? '+' + countrtCode + patientInfo?.mobileNumber : null,
                "dateOfBirth": formattedDate
            }

            const accessToken = data?.userData?.result?.token;
            setIsFetching(true);
            const response = await PersonalInformationService.updatePersonalInformation(obj, accessToken);
            if (response?.statusCode === 200) {
                // response?.result;
                // getFilePath()
                uploadInsuranceDocs();
                if (patientInfo.profile && patientInfo?.profile?.name) {
                    uploadDocs(patientInfo.profile, DocumentType?.patientProfileImage, true);
                }
                if (patientDocument[0] && patientDocument[0]?.answer?.name) {
                    uploadDocs(patientDocument[0]?.answer, DocumentType?.userPhotoIdImage);
                }

                setTimeout(() => {
                    setIsCropTool(false);
                    getPersonalInformation(true);
                }, 500);


            }
        } catch (error) {
            console.error('Error fetching top doctors:', error);
        }
        // navigate('/referral-confirmation');
        // Handle form submission here, e.g., send data to a server
    };

    // const getFilePath = async (file) => {
    //         if (file) {
    //             if (file.size > MAX_FILE_SIZE) {
    //               // If file is too large, compress it
    //               const options = {
    //                 maxSizeMB: 0.3, // Approximate target size
    //                 maxWidthOrHeight: 800, // Resize if needed
    //                 useWebWorker: true,
    //               };
          
    //               try {
    //                 const compressedFile = await imageCompression(file, options);
    //                 submitDocument(compressedFile);
    //                 // return compressedFile;
    //                 // setImage(compressedFile);
    //                 // setImageUrl(URL.createObjectURL(compressedFile));
    //                 console.log("Uploaded resized image:", compressedFile);
    //               } catch (error) {
    //                 console.error("Error compressing image:", error);
    //               }
    //             } else {
    //               // If file is within size limits, use it as is
    //               submitDocument(file);
    //             //   return file;
    //             //   setImage(file);
    //             //   setImageUrl(URL.createObjectURL(file));
    //               console.log("Uploaded original image:", file);
    //             }
    //           }
    //     }

        const compressImage = async (file) => {
            const options = {
                maxSizeMB: 0.3, // Target size in MB (~300 KB)
                maxWidthOrHeight: 800, // Adjust dimensions
                useWebWorker: true,
            };
            try {
                const compressedFile = await imageCompression(file, options);
                return compressedFile;
            } catch (error) {
                console.error("Error compressing image:", error);
                return file; // Return original file if compression fails
            }
        };
        
        const uploadInsuranceDocs = async () => {
            try {
                if (!patientDocument[1] || !patientDocument[2]) {
                    return;
                }
                const formDataRequest = new FormData();
        
                if (patientDocument[1]?.answer) {
                    let file = patientDocument[1]?.answer;
                    if(!file?.name){
                        return;
                    }
                    if (file.size > MAX_FILE_SIZE) {
                        file = await compressImage(file);
                    }
                    formDataRequest.append("InsuranceFront", file);
                }
        
                if (patientDocument[2]?.answer) {
                    if(!file?.name){
                        return;
                    }
                    let file = patientDocument[2]?.answer;
                    if (file.size > MAX_FILE_SIZE) {
                        file = await compressImage(file);
                    }
                    formDataRequest.append("InsuranceBack", file);
                }
        
                const accessToken = data?.userData?.result?.token;
                setIsFetching(true);
                const response = await DocumentService.uploadInsuranceDocs(formDataRequest, accessToken);
                if (response?.statusCode === 200) {
                    console.log("Insurance Uploaded:", response);
                }
            } catch (error) {
                console.error("Error uploading insurance documents:", error);
            }
        };
        
        const uploadDocs = async (file, type, isPersonalInfo) => {
            try {
                if (!file?.name) {
                    return;
                }
        
                if (file.size > MAX_FILE_SIZE) {
                    file = await compressImage(file);
                }
        
                const formDataRequest = new FormData();
                formDataRequest.append("FileToUpload", file);
                formDataRequest.append("DocumentType", type);
        
                const accessToken = data?.userData?.result?.token;
                setIsFetching(true);
                const response = await DocumentService.uploadDocs(formDataRequest, accessToken);
                if (response?.statusCode === 200) {
                    console.log("Identification Uploaded:", response);
                }
            } catch (error) {
                console.error("Error uploading documents:", error);
            }
        };

    // const uploadInsuranceDocs = async () => {
    //     try {
    //         if (!patientDocument[1] || !patientDocument[2]) {
    //             return
    //         }
    //         const formDataRequest = new FormData();
    //         if (patientDocument[1]?.answer) {
    //             const fileToUpload = new File([patientDocument[1]?.answer], "cropped_image.jpg", { type: "image/jpeg" });
    //             formDataRequest.append('InsuranceFront', fileToUpload);
    //         }
    //         if (patientDocument[2]?.answer) {
    //             const fileToUpload = new File([patientDocument[2]?.answer], "cropped_image.jpg", { type: "image/jpeg" });
    //             formDataRequest.append('InsuranceBack', fileToUpload);
    //         }

    //         const accessToken = data?.userData?.result?.token;
    //         setIsFetching(true);
    //         const response = await DocumentService.uploadInsuranceDocs(formDataRequest, accessToken);
    //         if (response?.statusCode === 200) {
    //             console.log('Insurance', response);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching top doctors:', error);
    //     }
    // }
    // const uploadDocs = async (file, type, isPersonalInfo) => {
    //     try {
    //         if (!file?.name) {
    //             return
    //         }
    //         // const fileToUpload = new File([file], "cropped_image.jpg", { type: "image/jpeg" });
    //         const formDataRequest = new FormData();
    //         if (file) {
    //             formDataRequest.append('FileToUpload', file);
    //             formDataRequest.append('DocumentType', type);
    //         }

    //         const accessToken = data?.userData?.result?.token;
    //         setIsFetching(true);
    //         const response = await DocumentService.uploadDocs(formDataRequest, accessToken);
    //         if (response?.statusCode === 200) {
    //             console.log('Identification', response);
    //         }
    //     } catch (error) {
    //         console.error('Error fetching top doctors:', error);
    //     }
    // }

    const setUploadImg = async (data) => {
        // setProfile(data);
        setPatientInfo({ ...patientInfo, ['profile']: data });
    }

    const handleUploadFileChange = (file, index) => {
        setPatientDocument((prev) => ({
            ...prev,
            [index]: { answer: file },
        }));
    };

    const handleGenderChange = (fieldName, event) => {
        setPatientInfo({ ...patientInfo, [fieldName]: event });
        if (fieldName === 'city') {
            getStateZipCodes(event);
        }
        if (fieldName === 'state') {
            const findStateId = states.find(x => x.name?.toLowerCase() === event?.toLowerCase())?.id;
            setStateId(findStateId);
            getCities(findStateId);
        }
    }
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setIsDatePicker(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    const handleBirthDate = () => {
        setIsDatePicker(false);
        let birthDate = null;
        let findDate = new Date(patientInfo?.dateOfBirth || new Date());
        if (formData?.day && formData?.month && formData?.year) {
            // Set full date if all fields are provided
            birthDate = `${formData.month}/${formData.day}/${formData.year}`;
        } else {
            // Update only the parts provided
            if (formData?.day) {
                findDate.setDate(formData.day);
            }
            if (formData?.month) {
                findDate.setMonth(formData.month); // Months are 0-indexed
            }
            if (formData?.year) {
                findDate.setFullYear(formData.year);
            }
            // Format updated date
            birthDate = findDate.toISOString().split("T")[0];
        }
        setPatientInfo({ ...patientInfo, ['dateOfBirth']: birthDate });
    }
    return (
        <>
            <div className="custom-container profile-content">
                <div className="referral-form">
                    <h4 className="page-title">Profile</h4>
                    <div className="row">
                        <div className="col-md-9">
                            <form className="insurance-card form-input-label">
                                <div className="">
                                    <ImageCropper defaultProfileIcon={'https://www.dgvaishnavcollege.edu.in/dgvaishnav-c/uploads/2021/01/dummy-profile-pic.jpg' || defaultIcon} formData={patientInfo} cameraIcon={cameraIcon} setUploadImg={setUploadImg} className={'profile-lbl '} addStoryIcon={addStoryIcon} isProfilePage={true} isCropTool={isCropTool} setIsCropTool={setIsCropTool} />
                                </div>
                                <div className="divider my-3"></div>
                                <div>
                                    <h5 className="referrals-title mb-3">Personal information</h5>
                                    <div className="row mb-3">
                                        <div className="col-md-6">
                                            <div className={`input-group max-width-290 form-item ${patientInfo.firstName?.trim() !== '' ? 'valid' : ''}`}>
                                                <Input inputType={'text'} id={'firstName'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('firstName')}
                                                    value={patientInfo.firstName} />
                                                <label htmlFor="firstName" className={patientInfo.firstName?.trim() !== '' ? 'is-active active' : 'active'} >First name</label>
                                                {patientInfo.firstName?.trim() !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.firstName && isSubmit ? errors.firstName : ''}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <div className={`input-group max-width-290 ${patientInfo.lastName?.trim() !== '' ? 'valid' : ''}`}>
                                                <Input inputType={'text'} id={'lastName'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('lastName')}
                                                    value={patientInfo.lastName} />
                                                <label htmlFor="lastName" className={patientInfo.lastName?.trim() !== '' ? 'is-active active' : 'active'}>Last name</label>
                                                {patientInfo.lastName?.trim() !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.lastName && isSubmit ? errors.lastName : ''}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <div className={`selection-content ${patientInfo.gender !== '' ? 'valid' : ''}`}>
                                                <Select
                                                    id={'gender'}
                                                    defaultValue={0}
                                                    list={genders}
                                                    value={patientInfo?.gender}
                                                    className={'bg-transparent'}
                                                    isProfile={true}
                                                    valueKey="value"
                                                    nameKey="name"
                                                    onChange={(value) => handleGenderChange('gender', value)}
                                                />
                                                <label htmlFor="gender" className={patientInfo.gender ? 'is-active active' : ' d-none active'}>Select gender</label>
                                                {patientInfo?.gender !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.gender && isSubmit ? errors.gender : ''}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <div className={`selection-content ${patientInfo.pronoun !== '' ? 'valid' : ''}`}>
                                                <Select
                                                    id={'pronoun'}
                                                    defaultValue={4}
                                                    list={pronouns}
                                                    value={patientInfo?.pronoun}
                                                    className={'bg-transparent'}
                                                    isProfile={true}
                                                    valueKey="value" // Default key
                                                    nameKey="name"
                                                    onChange={(value) => handleGenderChange('pronoun', value)}
                                                />
                                                <label htmlFor="pronoun" className={patientInfo.pronoun ? 'is-active active' : 'd-none active'}>Select pronoun</label>
                                                {patientInfo.pronoun !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.pronoun && isSubmit ? errors.pronoun : ''}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <div className={`input-group max-width-290 ${patientInfo.dateOfBirth !== '' ? 'valid' : ''}`}>
                                                <Input inputType={'text'} id={'dateOfBirth'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('dateOfBirth')}
                                                    value={patientInfo.dateOfBirth} />
                                                <label htmlFor="dateOfBirth" className={patientInfo?.dateOfBirth !== '' ? 'is-active active' : 'active'}>Date of birth</label>
                                                {patientInfo?.dateOfBirth !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.dateOfBirth && isSubmit ? errors.dateOfBirth : ''}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <div className={`input-group max-width-290 ${patientInfo?.mobileNumber ? 'valid' : 'valid'}`}>
                                                <Input inputType={'text'} id={'mobileNumber'} inputPlaceholder={''} className={'form-control mobile'} required={true} onChange={handleChange('mobileNumber')}
                                                    value={patientInfo.mobileNumber} isPhoneNumber={true} isProfile={true}  disabled={true}/>
                                                <label htmlFor="mobileNumber" className={patientInfo.mobileNumber ? 'is-active active mobile-lbl' : 'active mobile-lbl'}>Mobile number</label>
                                                {patientInfo?.mobileNumber && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.mobileNumber && isSubmit ? errors.mobileNumber : ''}</p>
                                        </div>
                                        <div className="col-12">
                                            <div className={`input-group ${patientInfo.email?.trim() !== '' ? 'valid' : ''}`}>
                                                <Input inputType={'email'} id={'email'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('email')}
                                                    value={patientInfo.email} />
                                                <label htmlFor="email" className={patientInfo.email?.trim() !== '' ? 'is-active active' : 'active'}>Email id</label>
                                                {patientInfo.email?.trim() !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.email && isSubmit ? errors.email : ''}</p>
                                        </div>
                                        <div className="col-12">
                                            <div className={`input-group ${patientInfo.streetAddress?.trim() !== '' ? 'valid' : ''}`}>
                                                <Input inputType={'text'} id={'streetAddress'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('streetAddress')}
                                                    value={patientInfo.streetAddress} />
                                                <label htmlFor="streetAddress" className={patientInfo.streetAddress?.trim() !== '' ? 'is-active active' : 'active'}>Street address</label>
                                                {patientInfo.streetAddress?.trim() !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.streetAddress && isSubmit ? errors.streetAddress : ''}</p>
                                        </div>
                                        <div className="col-12">
                                            <div className={`input-group ${patientInfo.aptSuite?.trim() !== '' ? 'valid' : ''}`}>
                                                <Input inputType={'text'} id={'aptSuite'} inputPlaceholder={''} className={'form-control'} required={true} onChange={handleChange('aptSuite')}
                                                    value={patientInfo.aptSuite} />
                                                <label htmlFor="aptSuite" className={patientInfo.aptSuite?.trim() !== '' ? 'is-active active' : 'active'}>Apt, suite (optional)</label>
                                                {patientInfo.aptSuite?.trim() !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.aptSuite && isSubmit ? errors.aptSuite : ''}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <div className={`selection-content ${patientInfo.state !== '' ? 'valid' : ''}`}>
                                                <Select
                                                    id={'state'}
                                                    defaultValue={0}
                                                    list={states || []}
                                                    value={patientInfo?.state || null}
                                                    className={'bg-transparent'}
                                                    valueKey="name"
                                                    nameKey="name"
                                                    isProfile={true}
                                                    onChange={(value) => handleGenderChange('state', value)}
                                                />
                                                <label htmlFor="state" className={patientInfo.state ? 'is-active active' : 'd-none active'}>Select state</label>
                                                {patientInfo.state !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.state && isSubmit ? errors.state : ''}</p>
                                        </div>
                                        <div className="col-md-6">
                                            <div className={`selection-content ${patientInfo.city !== '' ? 'valid' : ''}`}>
                                                <Select
                                                    id={'city'}
                                                    defaultValue={0}
                                                    list={cities || []}
                                                    value={patientInfo?.city || null}
                                                    className={'bg-transparent'}
                                                    valueKey="id"
                                                    nameKey="name"
                                                    isProfile={true}
                                                    onChange={(value) => handleGenderChange('city', value)}
                                                />
                                                <label htmlFor="city" className={patientInfo.city ? 'is-active active' : 'd-none active'}>Select city</label>
                                                {patientInfo.city !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.city && isSubmit ? errors.city : ''}</p>
                                        </div>
                                        
                                        <div className="col-md-6">
                                            <div className={`selection-content ${patientInfo.zipCode !== '' ? 'valid' : ''}`}>
                                                <Select
                                                    id={'zipCode'}
                                                    defaultValue={0}
                                                    list={zipCodeList || []}
                                                    value={patientInfo?.zipCode}
                                                    className={'bg-transparent'}
                                                    valueKey="id"
                                                    nameKey="zip"
                                                    isProfile={true}
                                                    onChange={(value) => handleGenderChange('zipCode', value)}
                                                />
                                                <label htmlFor="state" className={patientInfo.zipCode !== '' && patientInfo.zipCode !== 0 ? 'is-active active' : 'd-none active'}>Select zipCode</label>
                                                {patientInfo.zipCode !== 0 && patientInfo.zipCode !== '' && (
                                                    <CheckedImage />
                                                )}
                                            </div>
                                            <p className="is-error">{errors.zipCode && isSubmit ? errors.zipCode : ''}</p>
                                        </div>

                                        <div className="divider my-3"></div>
                                        <div className="documents-content">
                                            {isDocument && uploadDocuments?.map((item, index) => (
                                                <div className="" key={index}>
                                                    {item.title && <label className={'d-flex mt-3'}>{item.title}</label>}
                                                    <div className="document-uploads mt-3 row">
                                                        <UploadDocument
                                                            handleUploadFileChange={(file) => handleUploadFileChange(file, index)}
                                                            documentUploadList={item}
                                                            formData={patientDocument[index] || {}} // Example formData per title
                                                            multipleFormData={true}
                                                            isProfilePage={true}
                                                            isCropTool={isCropTool} setIsCropTool={setIsCropTool}
                                                            setValue={(updatedValue) =>
                                                                setPatientDocument((prev) => ({
                                                                    ...prev,
                                                                    [item.title]: { id: item.id, answer: updatedValue },
                                                                }))
                                                            }
                                                            buttonName="Upload"
                                                            btnClass="upload-btn"
                                                            isProfile={true}
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="justify-content-start mt-3 ">
                                            <Button btnType={'submit'}
                                                btnClass={'btn-primary question-btn '}
                                                btnName={'Save'}
                                                isDisabled={true}
                                                onClick={handleSubmit}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    {isDatePicker && (
                        <div className="fullscreen-overlay ">
                            <div className="fullscreen-overlay-content search-result-filter birth-date" ref={popupRef}>
                                <div className="date-of-birth-container">
                                    <h2 className="title">What is your date of birth?</h2>
                                    <DatePicker formData={formData} />
                                    {/* <SelectPicker formData={formData} /> */}
                                    <Button
                                        btnClass={'btn-primary custom-button-width mt-5'}
                                        btnType={'button'}
                                        btnName={'Submit'}
                                        onClick={handleBirthDate}
                                        isDisabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
};

export default Profile;